//listado de bancos

export const bancos = [
    { value: "0102", label: "0102 - BANCO DE VENEZUELA" },
    { value: "0104", label: "0104 - BANCO VENEZOLANO DE CRÉDITO" },
    { value: "0105", label: "0105 - BANCO MERCANTIL" },
    { value: "0108", label: "0108 - BANCO PROVINCIAL BBVA" },
    { value: "0114", label: "0114 - BANCO DEL CARIBE" },
    { value: "0115", label: "0115 - BANCO EXTERIOR" },
    { value: "0128", label: "0128 - BANCO CARONI" },
    { value: "0134", label: "0134 - BANESCO BANCO UNIVERSAL" },
    { value: "0137", label: "0137 - SOFITASA" },
    { value: "0138", label: "0138 - BANCO PLAZA" },
    { value: "0146", label: "0146 - BANGENTE" },
    { value: "0149", label: "0149 - BANCO DEL PUEBLO SOBERANO" },
    { value: "0151", label: "0151 - BFC" },
    { value: "0156", label: "0156 - 100% BANCO" },
    { value: "0157", label: "0157 - DELSUR" },
    { value: "0163", label: "0163 - BANCO DEL TESORO" },
    { value: "0166", label: "0166 - BANCO AGRICOLA" },
    { value: "0168", label: "0168 - BANCRECER" },
    { value: "0169", label: "0169 - MIBANCO" },
    { value: "0171", label: "0171 - BANCO ACTIVO" },
    { value: "0172", label: "0172 - BANCAMIGA BANCO" },
    { value: "0174", label: "0174 - BANPLUS BANCO COMERCIAL" },
    { value: "0175", label: "0175 - BANCO BICENTENARIO" },
    { value: "0177", label: "0177 - BANFANB" },
    { value: "0191", label: "0191 - BANCO NACIONAL DE CRÉDITO" },
  ];

export const telefonos = [
    {value: "0412", label:"0412"},
    {value: "0414", label:"0414"},
    {value: "0424", label:"0424"},
    {value: "0416", label:"0416"},
    {value: "0426", label:"0426"},
    {value: "0422", label:"0422"}
] 

export const documento = [
    {value: "V", label: "V"},
    {value: "E", label: "E"},
    {value: "J", label: "J"},
    {value: "G", label: "G"},
]

export const natural = [
    {value: "V", label: "V"},
    {value: "E", label: "E"},
    {value: "P", label: "P"},
]

export const juridico = [
    {value: "J", label: "J"},
    {value: "G", label: "G"},
    {value: "E", label: "E"},
    {value: "V", label: "V"},
]


export const internacional = [
    {value: "BINANCE", label: "Binance"},
    {value: "BOFA", label: "Cualquier Banco Internacional"}
]
  
  
